/**
 * Every string the code screen renders.
 *
 * The number is echoed in the lede so a mistyped digit is caught before the
 * operator waits for a message that will never arrive — that is the whole job
 * of that sentence, and it is why the screen has a way back to the identity
 * screen rather than only forward.
 *
 * The resend line states the **condition**, not the mechanic: a code cannot be
 * re-requested while the previous one is still alive, so the button is disabled
 * and the reason is written beside it rather than left for a failed press to
 * reveal.
 */
export const copy = {
  documentTitle: 'أدخل رمز الدخول — وحدة تحكّم شاهدني',

  head: {
    title: 'أدخل رمز الدخول',
    ledePrefix: 'أرسلنا رمزاً إلى ',
    ledeSuffix: '. أدخله هنا لإكمال الدخول إلى وحدة التحكّم.',
  },

  code: {
    label: 'رمز الدخول',
    hint: 'الرمز يصل في رسالة نصّية على الرقم أعلاه.',
  },

  actions: {
    confirm: 'تأكيد',
    resend: 'أعد إرسال الرمز',
    offline: 'لا اتّصال — أعد المحاولة بعد عودة الشبكة',
  },

  timer: {
    /** The count sits between the two halves; its glyphs are Arabic-Indic. */
    prefix: 'الرمز صالح ',
    suffix: ' ثانية بعد، ولا يمكن طلب رمز جديد قبل انتهائها.',
    /**
     * Spoken **once**, at the moment the button's state actually changes. A
     * counter updated every second is not a live region — it would flood a
     * screen reader with a number nobody asked to hear ticking.
     */
    expired: 'انتهت صلاحية الرمز، ويمكنك طلب رمز جديد الآن.',
    resent: 'أُرسل رمز جديد.',
  },

  foot: {
    wrongNumber: 'أدخلتَ رقماً خطأً؟ غيّر الرقم',
  },
} as const;
